<template>
  <div class="header__bar">
    <div
      class="header__burger"
      ref="burgerBtnRef"
      :class="{ burgerActive: openBurger === true }"
      @click="toggleBurger"
    >
      <span class="line"></span>
    </div>
    <ul class="burger" v-if="openBurger" ref="burgerMenuRef">
      <!-- <router-link to="/" class="burger__logo mx-auto">
        <img src="@/assets/images/logo.svg" />
      </router-link> -->

      <li class="burger-item">
        <router-link to="/">Главная</router-link>
      </li>
      <li class="burger-item">
        <router-link to="/counter-parties">Проверить компанию</router-link>
      </li>
      <li class="burger-item">
        <router-link to="/marketplace">Маркетплейс</router-link>
      </li>
      <li class="burger-item">
        <router-link to="/sellers">Для продавцов</router-link>
      </li>
      <li class="burger-item" v-if="isLoggedIn">
        <router-link to="/tariffs">Тарифы</router-link>
      </li>
      <li class="burger-item">
        <router-link to="/about">О компании</router-link>
      </li>
      <li class="burger-item">
        <router-link to="/blog">Блог</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  defineComponent,
  ref,
  watch,
  onMounted,
  onBeforeUnmount,
  computed,
} from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "Burger",
  setup() {
    const openDropdown = ref(false);
    const openBurger = ref(false);
    const route = useRoute();
    const burgerBtnRef = ref(null);
    const burgerMenuRef = ref(null);
    const store = useStore();
    const isLoggedIn = computed(() => store.state.auth.status.loggedIn);
    const toggleBurger = () => {
      openBurger.value = !openBurger.value;
    };
    const toggleDropdown = () => {
      if (!openDropdown.value) {
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "auto";
      }
      openDropdown.value = !openDropdown.value;
    };
    watch(route, () => {
      openDropdown.value = false;
      openBurger.value = false;
      document.documentElement.style.overflow = "auto";
    });

    const handleClickOutside = (e) => {
      const btn = burgerBtnRef.value;
      const menu = burgerMenuRef.value;

      if (!btn || !menu) return;

      if (!btn.contains(e.target) && !menu.contains(e.target)) {
        openBurger.value = false;
      }
    };

    onMounted(() => {
      document.addEventListener("click", handleClickOutside);
    });

    onBeforeUnmount(() => {
      document.removeEventListener("click", handleClickOutside);
    });
    return {
      isLoggedIn,
      openBurger,
      openDropdown,
      toggleBurger,
      toggleDropdown,
      burgerBtnRef,
      burgerMenuRef,
    };
  },
});
</script>
